// Older references such as B05 and current numbers such as B005 identify the same box.
export function boxKey(value) {
  const text = String(value || '').trim().toUpperCase();
  const match = text.match(/^B?0*(\d+)$/);
  return match ? `B${match[1]}` : text;
}

export function buildBoxGroups(matches, allBoxes) {
  const byNumber = new Map();
  for (const box of allBoxes) {
    const key = boxKey(box.box_nummer);
    if (!byNumber.has(key)) byNumber.set(key, box);
  }
  const matched = new Set(matches.map(box => box.id));
  const included = new Set(matched);
  // Keep the containing box visible as context when only its contents match a search.
  for (const box of matches) {
    let current = box;
    const seen = new Set([box.id]);
    while (current.parent_box) {
      const parent = byNumber.get(boxKey(current.parent_box));
      if (!parent || seen.has(parent.id)) break;
      included.add(parent.id);
      seen.add(parent.id);
      current = parent;
    }
  }
  const visible = allBoxes.filter(box => included.has(box.id));
  const children = new Map();
  const roots = [];
  for (const box of visible) {
    const parent = box.parent_box && byNumber.get(boxKey(box.parent_box));
    if (parent && parent.id !== box.id && included.has(parent.id)) {
      if (!children.has(parent.id)) children.set(parent.id, []);
      children.get(parent.id).push(box);
    } else roots.push(box);
  }
  const visited = new Set();
  const groups = [];
  function append(box, entries, depth) {
    if (visited.has(box.id)) return;
    visited.add(box.id);
    const parent = box.parent_box && byNumber.get(boxKey(box.parent_box));
    entries.push({ box, depth, isSub: Boolean(box.parent_box),
      parentNumber: parent ? parent.box_nummer : box.parent_box,
      contextOnly: !matched.has(box.id) });
    for (const child of children.get(box.id) || []) append(child, entries, depth + 1);
  }
  // The second pass also preserves malformed cyclic references instead of hiding boxes.
  for (const box of [...roots, ...visible]) {
    if (visited.has(box.id)) continue;
    const entries = [];
    append(box, entries, 0);
    groups.push(entries);
  }
  return groups;
}
